module.exports = __webpack_public_path__ + "static/media/bravo.bd4e0d7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bravo.mp3
// module id = ozWL
// module chunks = 1